import {
  Play,
  Sparkles,
  Plug,
  Wrench,
  Workflow,
  FileText,
  Lightbulb,
  Bot,
  Rocket,
} from "../../icons";
import type { PlayActionDTO, PlayKind } from "../../api/contracts/play";

/**
 * Per-kind presentation (label + icon + badge intent) shared by every Play
 * surface — the one-at-a-time driver and the inline home list — so a category
 * always reads the same wherever it appears.
 */
export const KIND_META: Record<
  PlayKind,
  {
    label: string;
    Icon: typeof Play;
    intent: "info" | "success" | "warning" | "danger" | "neutral";
  }
> = {
  onboarding: { label: "Setup", Icon: Rocket, intent: "info" },
  fix: { label: "Fixes", Icon: Wrench, intent: "danger" },
  integration: { label: "Connect", Icon: Plug, intent: "info" },
  automation: { label: "Automate", Icon: Workflow, intent: "success" },
  report: { label: "Review", Icon: FileText, intent: "neutral" },
  "next-action": { label: "Next steps", Icon: Lightbulb, intent: "neutral" },
  agent: { label: "From your agents", Icon: Bot, intent: "warning" },
  info: { label: "FYI", Icon: Sparkles, intent: "neutral" },
};

// Ranking mechanics, not motivation — never shown as a reason to act on a card.
const MECHANIC_REASONS = [
  "Down-weighted",
  "skipped this recently",
  "recency-adjusted",
  "Older suggestion",
];

/**
 * The user-facing "why" for an action: drop the ranking mechanics and the
 * payoff line (already surfaced on the badge row) so nothing is said twice.
 */
export function cleanReasons(action: PlayActionDTO): string[] {
  return action.reasons.filter(
    (r) => r !== action.payoff && !MECHANIC_REASONS.some((m) => r.includes(m)),
  );
}
